import { httpsCallable } from 'firebase/functions';
import { auth, functions, db, getToken, messaging } from './config';
import {
  EmailAuthProvider,
  reauthenticateWithCredential,
  signInWithEmailAndPassword,
  updatePassword,
  PhoneAuthProvider,
  RecaptchaVerifier,
  multiFactor,
  signInWithCredential,
  PhoneMultiFactorGenerator,
} from 'firebase/auth';
import { doc, getDoc, collection, setDoc, updateDoc } from 'firebase/firestore';
import Axios from 'axios';
import { sendSms } from './functions';
const generateVerificationCode = () => {
  return Math.floor(100000 + Math.random() * 900000).toString();
};
// Sign in an existing user with email and password
const signIn = async (email, password) => {
  const userCredential = await signInWithEmailAndPassword(
    auth,
    email,
    password,
  );
  return userCredential.user;
};
const sendEmailVerify = async (user, email) => {
  const generatedCode = generateVerificationCode();
  try {
    if (!user) {
      throw new Error('No user signed in.');
    }

    Axios.get(
      'https://us-central1-image-submission-system.cloudfunctions.net/handleEmail',
      {
        params: {
          to: email,
          code: generatedCode,
        },
      },
    );

    const userDocRef = doc(db, 'users', user.uid);
    await updateDoc(userDocRef, { verificationCode: generatedCode });
  } catch (error) {
    console.error('Error sending verification code:', error);
    throw new Error('Failed to send verification code.');
  }
};
// Send OTP to the user's phone for multi-factor authentication
const sendOtp = async (user, phoneNumber) => {
  const generatedCode = '147852';

  try {
    if (!user) {
      throw new Error('No user signed in.');
    }
    await sendSms({ phone: phoneNumber, code: generatedCode });
    const userDocRef = doc(db, 'users', user.uid);
    await updateDoc(userDocRef, { verificationCode: generatedCode });
  } catch (error) {
    console.error('Error sending verification code:', error);
    throw new Error('Failed to send verification code.');
  }
};
// Verify the OTP provided by the user
const verifyOtp = async (uid, otp) => {
  try {
    // Get the user's document reference
    const userDocRef = doc(db, 'users', uid);

    // Retrieve the user's document
    const userDocSnap = await getDoc(userDocRef);

    // Check if the document exists
    if (!userDocSnap.exists()) {
      throw new Error('User document does not exist.');
    }

    // Get the stored verification code
    const userData = userDocSnap.data();
    const storedVerificationCode = userData.verificationCode;
    // Compare the stored code with the provided OTP
    if (storedVerificationCode === otp) {
      // Optionally, you can mark the user as verified or remove the VerificationCode
      await updateDoc(userDocRef, {
        verificationCode: null,
        verified: true,
      });
      return true; // Verification successful
    } else {
      throw new Error('Incorrect verification code.');
    }
  } catch (error) {
    console.error('Error verifying OTP:', error);
    throw error; // Re-throw the error to handle it in the calling function
  }
};

// Change the password for the currently signed-in user
const changePassword = async (currentPassword, newPassword) => {
  const user = auth.currentUser;
  if (!user) {
    throw new Error('No user currently signed in.');
  }

  try {
    const credential = EmailAuthProvider.credential(
      user.email,
      currentPassword,
    );
    await reauthenticateWithCredential(user, credential);
  } catch (error) {
    return 'Current password is not correct.';
  }

  try {
    await updatePassword(user, newPassword);
    return '';
  } catch (error) {
    console.error('Error updating password: ', error);
    return 'Error updating password: ' + error;
  }
};

// Google cloud function to create users
const createOrEditUserFunction = httpsCallable(functions, 'createOrEditUser');
const deleteUserFunction = httpsCallable(functions, 'deleteUser');

export {
  signIn,
  changePassword,
  createOrEditUserFunction,
  deleteUserFunction,
  sendOtp,
  verifyOtp,
  sendEmailVerify,
};
